import { render, staticRenderFns } from "./AsiaCaseManagementCreate.vue?vue&type=template&id=3f15b4b2&scoped=true"
import script from "./AsiaCaseManagementCreate.vue?vue&type=script&lang=js"
export * from "./AsiaCaseManagementCreate.vue?vue&type=script&lang=js"
import style0 from "./AsiaCaseManagementCreate.vue?vue&type=style&index=0&id=3f15b4b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f15b4b2",
  null
  
)

export default component.exports